/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/page-not-found', {
      templateUrl: require('./page-not-found.template.html'),
      title: 'Seite nicht gefunden',
    });
}
